module.exports = __webpack_public_path__ + "static/media/Jellyfish_1_t.a50361d5.jpg";